import { DefaultAvatar } from '@/components/icons'

export type AvatarProps = {
  imageClassName?: string
  src?: string
  alt?: string
}

export const Avatar = ({ imageClassName, src, ...props }: AvatarProps) => {
  return (
    <div className="w-12 h-12 rounded-full overflow-hidden border-1 border-black">
      {src ? (
        <img src={src} className={`w-full h-full ${imageClassName ? imageClassName : ''}`} {...props} />
      ) : (
        <DefaultAvatar className="text-[#BDBDBD]" width={'3rem'} height={'3rem'} />
      )}
    </div>
  )
}

export default Avatar
